import React from 'react';
import PropTypes from 'prop-types';
import { PencilIcon } from '../../atoms/icons/EditorialProfileIcons';
import './index.scss';

export default function EditingModeBanner({
  message,
  hint,
  doneLabel = 'Done',
  onDone,
}) {
  return (
    <div className="editing-banner" role="status" aria-live="polite">
      <div className="editing-banner__inner">
        <div className="editing-banner__main">
          <span className="editing-banner__icon" aria-hidden="true">
            <PencilIcon width="14" height="14" />
          </span>
          <div className="editing-banner__text">
            <div className="editing-banner__title">{message}</div>
            {hint ? <div className="editing-banner__hint">{hint}</div> : null}
          </div>
        </div>
        {onDone ? (
          <button
            type="button"
            className="editing-banner__done"
            onClick={onDone}
          >
            {doneLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

EditingModeBanner.propTypes = {
  message: PropTypes.node.isRequired,
  hint: PropTypes.node,
  doneLabel: PropTypes.node,
  onDone: PropTypes.func,
};
